import { render, staticRenderFns } from "./IntroText.vue?vue&type=template&id=51620921&"
import script from "./IntroText.vue?vue&type=script&lang=js&"
export * from "./IntroText.vue?vue&type=script&lang=js&"
import style0 from "./IntroText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports